<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div class="member-card text-white rounded">
    <div class="member-card-details">
      <!--Name and ID-->
      <div class="card-id text-start d-flex">
        <h5 class="mb-0 card-name text-capitalize" *ngIf="memberDetails$ | async as memberDetails">
          {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
        </h5>
        <div class="d-flex font-size-14">
          <div>{{ memberCard.ExternalRefNumber }} - {{ 'member.card.id' | translate }}</div>
        </div>
      </div>
    </div>

    <!--Balances-->
    <div class="w-100">
      <fgb-balance-widgets></fgb-balance-widgets>
    </div>

    <!--Direct Auth-->
    <div class="w-100">
      <fgb-payment-button></fgb-payment-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
